import { MDBIcon } from "mdbreact";
import React, { useState } from "react";
import classes from "./Accordion.module.scss";
import TextDecoration, { LineElement } from "../text-decoration/TextDecoration";

/**
 * アコーディオンのプロパティ
 */
type AccordionProps = {
  /** アコーディオンタイトル */
  title: string;
  /** 箇条書きコンテンツ */
  contents: (string | LineElement)[];
  /** 背景色 */
  bgColor?: string;
};

/**
 * アコーディオン
 * @param props アコーディオンのプロパティ
 */
const Accordion: React.FC<AccordionProps> = (props) => {
  /** アコーディオンの開閉状態 */
  const [isOpen, setIsOpen] = useState(false);

  let customBgStyle = {};
  if (props.bgColor) {
    customBgStyle = { backgroundColor: props.bgColor };
  }

  /**
   * アコーディオン開閉状態の切り替え
   */
  const switchAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={classes.accordion} style={customBgStyle}>
      <div className={classes.header} onClick={switchAccordion}>
        <div className="w-100 d-table">
          <div className="d-table-cell">{props.title}</div>
          <div className="d-table-cell text-right">
            <MDBIcon icon="angle-down" rotate={isOpen ? "180" : undefined} />
          </div>
        </div>
      </div>

      {isOpen ? (
        <React.Fragment>
          <hr className={classes.sepLine} />
          <div className={classes.body}>
            {props.contents.every(
              (c: string | LineElement) => typeof c === "string"
            ) ? (
              <ul className={classes.list}>
                {props.contents.map((c, idx) => {
                  return (
                    <li className={classes.item} key={idx}>
                      {c}
                    </li>
                  );
                })}
              </ul>
            ) : (
              <TextDecoration
                sentences={props.contents as LineElement[]}
              ></TextDecoration>
            )}
          </div>
        </React.Fragment>
      ) : null}
    </div>
  );
};

export default Accordion;
